type CultureTranslations = Record<string, string>;
type TranslationCatalog = Record<string, CultureTranslations>;

const translations: TranslationCatalog = {
  ConversationExpander: {
    "en-GB": "Conversation",
    "da-DK": "Conversation",
    "fi-FI": "Keskustelu",
    "sv-FI": "Meddelanden",
    "sv-SE": "Meddelanden",
    "nb-NO": "Meldinger",
  },

  Sender: {
    "en-GB": "Sender",
    "da-DK": "Afsender",
    "fi-FI": "Lähettäjä",
    "sv-FI": "Avsändare",
    "sv-SE": "Avsändare",
    "nb-NO": "Avsender",
  },

  Subject: {
    "en-GB": "Subject",
    "da-DK": "Subject",
    "fi-FI": "Aihe",
    "sv-FI": "Ämne",
    "sv-SE": "Ämne",
    "nb-NO": "Meldingen gjelder",
  },

  SentDate: {
    "en-GB": "Sent",
    "da-DK": "Sendt",
    "fi-FI": "Lähetetty",
    "sv-FI": "Skickat",
    "sv-SE": "Skickat",
    "nb-NO": "Sendt",
  },

  Customer: {
    "en-GB": "Customer",
    "da-DK": "Customer",
    "fi-FI": "Asiakas",
    "sv-FI": "Kund",
    "sv-SE": "Kund",
    "nb-NO": "Customer",
  },

  Claim: {
    "en-GB": "Claim",
    "da-DK": "Skade",
    "fi-FI": "Vahinko",
    "sv-FI": "Skada",
    "sv-SE": "Skada",
    "nb-NO": "Skade",
  },

  Frontliner: {
    "en-GB": "Customer service",
    "da-DK": "If",
    "fi-FI": "If",
    "sv-FI": "If",
    "sv-SE": "If",
    "nb-NO": "If",
  },

  PrefilledInfoTitle: {
    "en-GB": "Pre-filled",
    "da-DK": "Opstillet spørgsmål",
    "fi-FI": "Esitäytetty",
    "sv-FI": "Förhandsifylld",
    "sv-SE": "Färdiga frågor",
    "nb-NO": "Ferdig utfylte spørsmål",
  },

  PrefilledInfo: {
    "en-GB":
      "We have pre-filled some questions for you in the reply section below, that we need answers to. You can also add other relevant information to your answer.",
    "da-DK":
      "Vi har på forhånd stillet en række spørgsmål som vi beder dig svare på, dette kan du gøre i svarfeltet nedenfor. Du kan også vedlægge anden relevant information i dit svar.",
    "fi-FI":
      "Olemme esitäyttäneet alla olevan vastauskentän kysymyksillä, joihin tarvitsemme vastauksia. Voit lisätä vastaukseen myös muuta lisätietoa.",
    "sv-FI":
      "Vi har i förväg fyllt i några frågor till dig som vi behöver svar på, i svarsfältet nedan. Du kan också lägga till annan relevant information i ditt svar.",
    "sv-SE":
      "Vi har i förväg fyllt i några frågor till dig som vi behöver svar på, i svarsfältet nedan. Du kan också lägga till annan relevant information i ditt svar.",
    "nb-NO":
      "Vi har forhåndsutfylt noen spørsmål som vi trenger svar på, i svarfeltet under. Du kan også legge til annen relevant informasjon i svaret ditt.",
  },

  ReplyToHeader: {
    "en-GB": "Reply to message",
    "da-DK": "Besvar besked",
    "fi-FI": "Vastaa viestiin",
    "sv-FI": "Svara på meddelandet",
    "sv-SE": "Svara på meddelandet",
    "nb-NO": "Svar på melding",
  },

  AttachmentsHeader: {
    "en-GB": "Attachments",
    "da-DK": "Attachments",
    "fi-FI": "Liitteet",
    "sv-FI": "Bifogade filer",
    "sv-SE": "Bifogade filer",
    "nb-NO": "Vedlegg",
  },

  AddingAttachmentsHeader: {
    "en-GB": "Adding attachments",
    "da-DK": "Vedhæft filer",
    "fi-FI": "Lisää liitteitä",
    "sv-FI": "Bifoga filer",
    "sv-SE": "Bifoga filer här",
    "nb-NO": "Vedlegg",
  },

  AddingAttachmentsGeneralText: {
    "en-GB":
      "This is filler text for informing the customer about the attachments.",
    "da-DK": "Vedhæft eventuelle filer her.",
    "fi-FI": "",
    "sv-FI": "",
    "sv-SE": "",
    "nb-NO":
      "Her kan du laste opp filtypene xls, ppt, doc, pdf, jpg, jpeg, tif, tiff, txr, xlsx, pptx og png. Maks størrelse er 100 MB.",
  },

  AddingAttachmentInstructionsForClaimBeforeText: {
    "en-GB": "",
    "da-DK": "",
    "fi-FI": "",
    "sv-FI": "",
    "sv-SE":
      "Vill du bifoga en fil relaterad till en redan anmäld skada? Gå till ",
    "nb-NO": "",
  },

  AddingAttachmentInstructionsForClaimAfterText: {
    "en-GB": "",
    "da-DK": "",
    "fi-FI": "",
    "sv-FI": "",
    "sv-SE":
      ", välj den aktuella skadan och skicka ditt meddelande med filen bifogad.",
    "nb-NO": "",
  },

  AddingAttachmentsFileRequirementsText: {
    "en-GB":
      "This is filler text for informing the customer about attachment restrictions, such as file size and file type.",
    "da-DK":
      "Vi understøtter følgende filtyper: xls, ppt, doc, pdf, gif, jpg, jpeg, tif, tiff, txt, rtf, docx, xlsx, pptx, png, heic, heif. Den samlede mængde vedhæftelser må ikke overstige 100 mega bytes.",
    "fi-FI":
      "Seuraavat tiedostomuodot ovat sallittuja: xls, ppt, doc, pdf, gif, jpg, jpeg, tif, tiff, txt, rtf, docx, xlsx, pptx, png, heic, heif. Tiedostojen yhteenlaskettu enimmäiskoko voi olla enintään 100 MB.",
    "sv-FI":
      "Du kan ladda upp följande filformat: xls, ppt, doc, pdf, gif, jpg, jpeg, tif, tiff, txt, rtf, docx, xlsx, pptx, png, heic, heif. Summan på filerna får inte överstiga 100 MB.",
    "sv-SE":
      "Du kan ladda upp följande filformat: xls, ppt, doc, pdf, gif, jpg, jpeg, tif, tiff, txt, rtf, docx, xlsx, pptx, png, heic, heif. Summan på filerna får inte överstiga 100 megabyte.",
    "nb-NO": "",
  },

  AddingAttachmentsDropAreaText: {
    "da-DK": " for at vedhæfte dine filer manuelt eller træk dem ind her.",
    "fi-FI": "",
    "sv-FI": "",
    "en-GB": "Drag your files here or select them manually by ",
    "sv-SE": "eller använd dra och släpp",
    "nb-NO":
      " for å velge vedlegg, eller du kan dra vedleggene rett inn i denne ruten.",
  },

  AddingAttachmentsDropAreaBrowseButtonText: {
    "da-DK": "Klik her",
    "fi-FI": "Lisää liitetiedosto",
    "sv-FI": "Bifoga fil",
    "en-GB": "Clicking here",
    "sv-SE": "Ladda upp din fil ",
    "nb-NO": "Klikk her",
  },

  AddingAttachmentsDropAreaDragRejectText: {
    "da-DK": "Filtypen er ikke understøttet.",
    "fi-FI": "Liitteen tiedostomuoto ei ole tuettu.",
    "sv-FI": "Filformatet stöds inte.",
    "en-GB": "Unsupported file type...",
    "sv-SE": "Vi har inte stöd för det här filformatet.",
    "nb-NO": "Vi støtter ikke dette filformatet.",
  },

  AddingAttachmentsDropAreaDragAcceptText: {
    "da-DK": "Træk filen ind her.",
    "fi-FI": "Irrota ja liitä tiedosto.",
    "sv-FI": "Dra filen hit.",
    "en-GB": "Now, release it!",
    "sv-SE": "Dra filen hit.",
    "nb-NO": "Dra vedlegget hit.",
  },

  AddingAttachmentsInvalidFileErrorMessage: {
    "en-GB": "The file type is not correct.",
    "da-DK": "Filtypen er ikke understøttet.",
    "fi-FI": "Liitteen tiedostomuoto ei ole oikea.",
    "sv-FI": "Filformatet är inte korrekt.",
    "sv-SE": "Filformatet är inte korrekt.",
    "nb-NO": "Vi støtter ikke dette filformatet.",
  },

  AddingAttachmentsInvalidTotalFileSizeExceededErrorMessage: {
    "en-GB": "The total file size maximum exceeded.",
    "da-DK": "Den samlede filstørrelse er for stor.",
    "fi-FI":
      "Liitteiden yhteenlaskettu enimmäiskoko ylittyy. Liitteiden koko voi olla yhteensä enintään 100 MB.",
    "sv-FI":
      "Sammanlagda maximala storleken på bilagor överskrids. Bilagornas storlek kan vara högst 100 MB totalt.",
    "sv-SE": "Filen har överskridit maxstorlek.",
    "nb-NO": "Maksimal samlet vedleggsstørrelse er overskredet.",
  },

  AddingAttachmentsFileUploadErrorMessage: {
    "en-GB": "...Upload failed!",
    "da-DK": "...Upload fejlede!",
    "fi-FI": "Liitteen lataaminen epäonnistui. Ole hyvä ja yritä uudelleen.",
    "sv-FI":
      "Uppladdningen av bilagan misslyckades. Var god och försök på nytt.",
    "sv-SE": "...Uppladdningen misslyckades!",
    "nb-NO": "Kan ikke laste opp vedlegg!",
  },

  AddingAttachmentsFileUploadCompletedMessage: {
    "en-GB": "...Upload complete!",
    "da-DK": "...Upload er gennemført!",
    "fi-FI": "Liitteen lataaminen onnistui.",
    "sv-FI": "Uppladdningen av bilagan lyckades.",
    "sv-SE": "...Uppladdningen är slutförd!",
    "nb-NO": "Vedlegg lastet opp!",
  },

  AddingAttachmentsFileUploadCancelledMessage: {
    "en-GB": "...Upload cancelled!",
    "da-DK": "...Upload afbrudt!",
    "fi-FI": "Liitteen lataaminen on keskeytetty.",
    "sv-FI": "Uppladdningen av bilagan är avbruten.",
    "sv-SE": "...Uppladdningen är avbruten!",
    "nb-NO": "Opplasting av vedlegg er avbrutt!",
  },

  AttachmentScanInProgressText: {
    "en-GB": "Scan in progress...",
    "da-DK": "Scanning er under behandling...",
    "fi-FI": "Virusskannaus on käynnissä.",
    "sv-FI": "Viruskontroll pågår.",
    "sv-SE": "Filen scannas...",
    "nb-NO": "Skanning pågår...",
  },

  AttachmentScanRejectedText: {
    "en-GB": "Attachment was rejected!",
    "da-DK": "Vedhæftelse blev afvist!",
    "fi-FI": "Liite on hylätty.",
    "sv-FI": "Bilagan avvisades.",
    "sv-SE": "Den bifogade filen var kunde inte tas emot.",
    "nb-NO": "Vedlegget ble avvist.",
  },

  SendReply: {
    "en-GB": "Reply",
    "da-DK": "Besvar",
    "fi-FI": "Lähetä",
    "sv-FI": "Sänd",
    "sv-SE": "Svara",
    "nb-NO": "Svar",
  },

  MessageBodyPlaceholder: {
    "en-GB": "Write your message here",
    "da-DK": "Forklar gerne nærmere her",
    "fi-FI": "Kirjoita viestisi tähän",
    "sv-FI": "Skriv ditt meddelande här",
    "sv-SE": "Skriv ditt meddelande här",
    "nb-NO": "Din melding",
  },

  ReplyToMessageBodyPlaceholder: {
    "en-GB": "Write your message here",
    "da-DK": "Forklar gerne nærmere her",
    "fi-FI": "Kirjoita viestisi tähän",
    "sv-FI": "Skriv ditt meddelande här",
    "sv-SE": "Skriv ditt meddelande här",
    "nb-NO": "Din melding",
  },

  NewMessageHeader: {
    "en-GB": "New message",
    "da-DK": "New message",
    "fi-FI": "Uusi viesti",
    "sv-FI": "Nytt meddelande",
    "sv-SE": "Nytt meddelande",
    "nb-NO": "Skriv ny melding",
  },

  SendMessage: {
    "en-GB": "Send message",
    "da-DK": "Send besked",
    "fi-FI": "Lähetä viesti",
    "sv-FI": "Skicka meddelandet",
    "sv-SE": "Skicka meddelandet",
    "nb-NO": "Send melding",
  },

  ReplySent: {
    "en-GB": "Message sent",
    "da-DK": "Besked afsendt",
    "fi-FI": "Viesti lähetetty.",
    "sv-FI": "Meddelandet har sänts.",
    "sv-SE": "Meddelandet är skickat",
    "nb-NO": "Meldingen er sendt",
  },

  MessageSubjectPlaceholder: {
    "en-GB": "Write subject here",
    "da-DK": "Hvad drejer det sig om?",
    "fi-FI": "Kirjoita viestin aihe tähän",
    "sv-FI": "Skriv ditt ämne här",
    "sv-SE": "Beskriv ditt ärende",
    "nb-NO": "Hva trenger du hjelp til? Skriv en kort beskrivelse her",
  },

  MessageSubject: {
    "en-GB": "Subject",
    "da-DK": "Overskrift",
    "fi-FI": "Viestin aihe",
    "sv-FI": "Ämne",
    "sv-SE": "Rubrik",
    "nb-NO": "Meldingen gjelder",
  },

  MessageBody: {
    "en-GB": "Message",
    "da-DK": "Besked",
    "fi-FI": "Viesti",
    "sv-FI": "Meddelanden",
    "sv-SE": "Meddelande",
    "nb-NO": "Melding",
  },

  EnterSSN: {
    "en-GB": "The insured person's social security number",
    "da-DK": "Indtast dit CPR-nummer",
    "fi-FI": "Vakuutetun henkilötunnus",
    "sv-FI": "Den försäkrades personbeteckning",
    "sv-SE": "Ange ditt personnummer",
    "nb-NO": "Skriv inn ditt fødselsnummer",
  },

  EnterSSNPlaceholder: {
    "en-GB": "Enter the insured person's social security number",
    "da-DK": "Indtast dit CPR-nummer",
    "fi-FI": "Anna vakuutetun henkilötunnus",
    "sv-FI": "Personbeteckning",
    "sv-SE": "Skriv in ditt personnummer",
    "nb-NO": "Skriv inn ditt fødselsnummer",
  },

  SSNValidationError: {
    "en-GB": "Please enter a valid social security number",
    "da-DK": "Indtast venligst et gyldigt CPR-nummer",
    "fi-FI": "Tarkista henkilötunnus",
    "sv-FI": "Kontrollera att personbeteckningen är rätt ifylld",
    "sv-SE": "Ange ett giltigt personnummer",
    "nb-NO": "Skriv inn et gyldig fødselsnummer",
  },

  SSNBody: {
    "en-GB": "The insured person's social security number",
    "da-DK": "CPR-nummer",
    "fi-FI": "Vakuutetun henkilötunnus",
    "sv-FI": "Den försäkrades personbeteckning",
    "sv-SE": "Personnummer",
    "nb-NO": "Fødselsnummer",
  },

  CancelSending: {
    "en-GB": "Cancel",
    "da-DK": "Fortryd",
    "fi-FI": "Peruuta",
    "sv-FI": "Avbryt",
    "sv-SE": "Avbryt",
    "nb-NO": "Tilbake",
  },

  OneOrMoreNewMessages: {
    "en-GB": "New",
    "da-DK": "Ny besked modtaget",
    "fi-FI": "Uusi viesti",
    "sv-FI": "Nytt meddelande",
    "sv-SE": "Nytt meddelande",
    "nb-NO": "Ny melding",
  },

  NewMessage: {
    "en-GB": "New",
    "da-DK": "Ny",
    "fi-FI": "Uusi viesti",
    "sv-FI": "Nytt meddelande",
    "sv-SE": "Nytt meddelande",
    "nb-NO": "Ny melding",
  },

  ConversationClosedStatus: {
    "en-GB": "Closed",
    "da-DK": "Afsluttet",
    "fi-FI": "Suljettu",
    "sv-FI": "Avslutad",
    "sv-SE": "Avslutad",
    "nb-NO": "Avsluttet",
  },

  ConversationClosedHeaderText: {
    "en-GB": "This conversation has been closed",
    "da-DK": "Denne besked kan ikke besvares",
    "fi-FI": "Tämä keskustelu on suljettu.",
    "sv-FI": "Konversationen är avslutad.",
    "sv-SE": "Konversationen är avslutad",
    "nb-NO": "Samtalen er avsluttet",
  },

  ConversationClosedInformationText: {
    "en-GB":
      "This conversation has been marked as closed and no further messages can be sent. If you need to contact us, please call our customer support center.",
    "da-DK":
      "Dette er en automatisk genereret besked og kan ikke besvares. Men du er meget velkommen til atkontakte kundeservice via Mine sider, vores chat funktion eller ringe på 70 12 12 12 tast 2.",
    "fi-FI":
      "Asiakaspalvelumme on sulkenut tämän keskustelun, etkä voi enää lähettää viestejä tähän viestiketjuun. Jos sinulla on vielä kysyttävää, lähetä uusi viesti.",
    "sv-FI":
      "Vår kundtjänst har stängt den här konversationen och du kan inte längre skicka meddelanden i den här meddelandetråden. Om du har fler frågor, skicka ett nytt meddelande.",
    "sv-SE":
      "Konversationen är avslutad av kundtjänst och du kan inte svara på det här meddelandet längre. Om du har fler frågor kan du kontakta oss via chat eller telefon.",
    "nb-NO":
      "Samtalen er avsluttet og kan ikke lengre besvares. Kontakt oss hvis du har spørsmål.",
  },

  LoadMore: {
    "en-GB": "Load more",
    "da-DK": "Hent flere",
    "fi-FI": "Näytä lisää",
    "sv-FI": "Visa fler",
    "sv-SE": "Öppna fler meddelanden",
    "nb-NO": "Se flere meldinger",
  },

  MessageCategory: {
    "en-GB": "Message category",
    "da-DK": "Hvad drejer beskeden sig om?",
    "fi-FI": "Viestin aihe",
    "sv-FI": "Ämne",
    "sv-SE": "Ämne",
    "nb-NO": "Hva vil du skrive til oss om?",
  },

  MessageCategory_Animal: {
    "en-GB": "Animal",
    "da-DK": "Animal",
    "fi-FI": "Animal",
    "sv-FI": "Djur",
    "sv-SE": "Djur",
    "nb-NO": "Animal",
  },

  MessageCategory_BoatDamageClaim: {
    "en-GB": "BoatDamageClaim",
    "da-DK": "BoatDamageClaim",
    "fi-FI": "Venevahinko",
    "sv-FI": "Båtskada",
    "sv-SE": "BoatDamageClaim",
    "nb-NO": "BoatDamageClaim",
  },

  MessageCategory_BuyInsurance: {
    "en-GB": "BuyInsurance",
    "da-DK": "BuyInsurance",
    "fi-FI": "Vakuutuksen osto",
    "sv-FI": "Köp av försäkring",
    "sv-SE": "BuyInsurance",
    "nb-NO": "BuyInsurance",
  },

  MessageCategory_CancelInsurance: {
    "en-GB": "CancelInsurance",
    "da-DK": "CancelInsurance",
    "fi-FI": "Vakuutuksen päättäminen",
    "sv-FI": "Avslutande av försäkringen",
    "sv-SE": "CancelInsurance",
    "nb-NO": "CancelInsurance",
  },

  MessageCategory_Cancellations: {
    "en-GB": "Cancellations",
    "da-DK": "Opsig forsikring",
    "fi-FI": "Cancellations",
    "sv-FI": "Cancellations",
    "sv-SE": "Cancellations",
    "nb-NO": "Cancellations",
  },

  MessageCategory_CarDamageClaim: {
    "en-GB": "CarDamageClaim",
    "da-DK": "CarDamageClaim",
    "fi-FI": "Ajoneuvovahinko",
    "sv-FI": "Fordonsskada",
    "sv-SE": "CarDamageClaim",
    "nb-NO": "CarDamageClaim",
  },

  MessageCategory_ConstructionDamageClaim: {
    "en-GB": "ConstructionDamageClaim",
    "da-DK": "ConstructionDamageClaim",
    "fi-FI": "Rakennuksen muut vahingot",
    "sv-FI": "Övriga byggnadsskador",
    "sv-SE": "ConstructionDamageClaim",
    "nb-NO": "ConstructionDamageClaim",
  },

  MessageCategory_Claims: {
    "en-GB": "Claims",
    "da-DK": "Claims",
    "fi-FI": "Vahingot",
    "sv-FI": "Vahingot",
    "sv-SE": "Claims",
    "nb-NO": "Claims",
  },

  MessageCategory_Estate: {
    "en-GB": "Estate",
    "da-DK": "Estate",
    "fi-FI": "Kuolinpesä",
    "sv-FI": "Dödsbo",
    "sv-SE": "Estate",
    "nb-NO": "Estate",
  },

  MessageCategory_ForestDamageClaim: {
    "en-GB": "ForestDamageClaim",
    "da-DK": "ForestDamageClaim",
    "fi-FI": "Metsävahinko",
    "sv-FI": "Skogskada",
    "sv-SE": "ForestDamageClaim",
    "nb-NO": "ForestDamageClaim",
  },

  MessageCategory_General: {
    "en-GB": "General",
    "da-DK": "Spørgsmål til dine forsikringer",
    "fi-FI": "Yleiset vakuutusasiat",
    "sv-FI": "Övriga försäkringsärenden",
    "sv-SE": "Fråga om försäkring",
    "nb-NO": "Andre henvendelser",
  },

  MessageCategory_HealthAssessment: {
    "en-GB": "Health assessment",
    "da-DK": "Sundhedsvurdering",
    "fi-FI": "Terveysselvitys",
    "sv-FI": "Hälsobedömning",
    "sv-SE": "Hälsobedömning",
    "nb-NO": "Helsevurdering/Begunstigelse",
  },

  MessageCategory_InsuranceMatter: {
    "en-GB": "InsuranceMatter",
    "da-DK": "InsuranceMatter",
    "fi-FI": "Vakuutusasia",
    "sv-FI": "Försäkringsärende",
    "sv-SE": "InsuranceMatter",
    "nb-NO": "InsuranceMatter",
  },

  MessageCategory_Invoicing: {
    "en-GB": "Invoicing",
    "da-DK": "Invoicing",
    "fi-FI": "Laskutus",
    "sv-FI": "Fakturering",
    "sv-SE": "Invoicing",
    "nb-NO": "Betaling og faktura",
  },

  MessageCategory_LegalClaim: {
    "en-GB": "LegalClaim",
    "da-DK": "LegalClaim",
    "fi-FI": "Oikeusturvavahinko",
    "sv-FI": "Rättsskyddsskada",
    "sv-SE": "LegalClaim",
    "nb-NO": "LegalClaim",
  },

  MessageCategory_LiabilityClaim: {
    "en-GB": "LiabilityClaim",
    "da-DK": "LiabilityClaim",
    "fi-FI": "Vastuuvahinko",
    "sv-FI": "Ansvarsskada",
    "sv-SE": "LiabilityClaim",
    "nb-NO": "LiabilityClaim",
  },

  MessageCategory_ManualTask: {
    "en-GB": "ManualTask",
    "da-DK": "ManualTask",
    "fi-FI": "ManualTask",
    "sv-FI": "ManualTask",
    "sv-SE": "ManualTask",
    "nb-NO": "Endringer i forsikringen",
  },

  MessageCategory_MotorClaims: {
    "en-GB": "Claims on motor insurances",
    "da-DK": "Skade på køretøj eller båd",
    "fi-FI": "Ajoneuvovahinko",
    "sv-FI": "Fordonskada",
    "sv-SE": "Claims on motor insurances",
    "nb-NO": "Claims on motor insurances",
  },

  MessageCategory_Response: {
    "en-GB": "Response",
    "da-DK": "Response",
    "fi-FI": "Anna palautetta",
    "sv-FI": "Ge respons",
    "sv-SE": "Response",
    "nb-NO": "Response",
  },

  MessageCategory_PersonClaims: {
    "en-GB": "Claims on yourself or another person",
    "da-DK": "Personskade eller tandskade",
    "fi-FI": "Henkilövahinko",
    "sv-FI": "Personskada",
    "sv-SE": "Claims on yourself or another person",
    "nb-NO": "Claims on yourself or another person",
  },

  MessageCategory_ConstructionLeakageAndFire: {
    "en-GB": "Leakage and fire",
    "da-DK": "Leakage and fire",
    "fi-FI": "Rakennuksen vesi- ja palovahingot",
    "sv-FI": "Byggnadens vatten- och brandskador",
    "sv-SE": "Leakage and fire",
    "nb-NO": "Leakage and fire",
  },

  MessageCategory_PersonalInjuryClaim: {
    "en-GB": "PersonalInjuryClaim",
    "da-DK": "PersonalInjuryClaim",
    "fi-FI": "Henkilövahinko",
    "sv-FI": "Personskada",
    "sv-SE": "PersonalInjuryClaim",
    "nb-NO": "PersonalInjuryClaim",
  },

  MessageCategory_PersonalInjuryInTrafficClaim: {
    "en-GB": "PersonalInjuryClaim",
    "da-DK": "PersonalInjuryClaim",
    "fi-FI": "Henkilövahinko liikenteessä",
    "sv-FI": "Personskada i trafik",
    "sv-SE": "PersonalInjuryClaim",
    "nb-NO": "PersonalInjuryClaim",
  },

  MessageCategory_PetClaim: {
    "en-GB": "PetClaim",
    "da-DK": "PetClaim",
    "fi-FI": "Seuraeläinvahinko",
    "sv-FI": "Djurskada",
    "sv-SE": "PetClaim",
    "nb-NO": "PetClaim",
  },

  MessageCategory_PropertyLuggageClaim: {
    "en-GB": "Claims on your belongings, house, dog or other people's stuff",
    "da-DK": "Claims on your belongings, house, dog or other people's stuff",
    "fi-FI": "Matkatavaravahinko",
    "sv-FI": "Resgodsskada",
    "sv-SE": "Claims on your belongings, house, dog or other people's stuff",
    "nb-NO": "Claims on your belongings, house, dog or other people's stuff",
  },

  MessageCategory_PropertyClaims: {
    "en-GB": "Claims on your belongings, house, dog or other people's stuff",
    "da-DK": "Skade på hus, indbo eller dyr",
    "fi-FI": "Omaisuusvahinko",
    "sv-FI": "Egendomskada",
    "sv-SE": "Claims on your belongings, house, dog or other people's stuff",
    "nb-NO": "Claims on your belongings, house, dog or other people's stuff",
  },

  MessageCategory_PropertyDamageClaim: {
    "en-GB": "PropertyDamageClaim",
    "da-DK": "PropertyDamageClaim",
    "fi-FI": "Esinevahinko",
    "sv-FI": "Lösöreskada",
    "sv-SE": "PropertyDamageClaim",
    "nb-NO": "PropertyDamageClaim",
  },

  MessageCategory_RiskSelection: {
    "en-GB": "Risk selection",
    "da-DK": "Risk selection",
    "fi-FI": "Terveysselvitys henkilövakuutukseen",
    "sv-FI": "Hälsodeklaration personförsäkring",
    "sv-SE": "Hälsodeklaration personförsäkring",
    "nb-NO": "Risk selection",
  },

  MessageCategory_SelectMessageCategory: {
    "en-GB": "Select message category",
    "da-DK": "Vælg kategori",
    "fi-FI": "Valitse viestin aihealue",
    "sv-FI": "Välj ämne",
    "sv-SE": "Välj kategori",
    "nb-NO": "Velg",
  },

  MessageCategory_TravelClaims: {
    "en-GB": "Claims on travel insurance",
    "da-DK": "Skade på rejse eller afbestilling",
    "fi-FI": "Claims on travel insurance",
    "sv-FI": "Claims on travel insurance",
    "sv-SE": "Claims on travel insurance",
    "nb-NO": "Claims on travel insurance",
  },

  MessageCategory_TravelInterruptionClaim: {
    "en-GB": "Claims on travel insurance",
    "da-DK": "Claims on travel insurance",
    "fi-FI": "Matkan peruuntuminen tai keskeytyminen",
    "sv-FI": "Avbokning av resa",
    "sv-SE": "Claims on travel insurance",
    "nb-NO": "Claims on travel insurance",
  },

  MessageCategory_TravelInjuryClaim: {
    "en-GB": "Claims on travel insurance",
    "da-DK": "Claims on travel insurance",
    "fi-FI": "Sairaus tai tapaturma matkalla",
    "sv-FI": "Sjukdom eller olycksfall på resa",
    "sv-SE": "Claims on travel insurance",
    "nb-NO": "Claims on travel insurance",
  },

  CategoryNotification_Title: {
    "en-GB": "Notice:",
    "da-DK": "Vær opmærksom på:",
    "fi-FI": "Huomaa:",
    "sv-FI": "Notera:",
    "sv-SE": "Notera:",
    "nb-NO": "Notice:",
  },

  CategoryNotification_MotorClaims: {
    "en-GB":
      "Here you can write to us about ongoing claims. If you need to report a new claim, you can do this here:",
    "da-DK":
      "Her kan du skrive til os om igangværende eller tidligere skadesager. Skal du anmelde en ny skade, kan du gøre det her:",
    "fi-FI":
      "Tässä voit lähettää viestin keskeneräiseen vahinkoasiaan liittyen. Uudesta vahingosta voit ilmoittaa täällä:",
    "sv-FI":
      "Här kan du skicka meddelande om pågående skada. Du kan anmäla en ny skada här:",
    "sv-SE":
      "Here you can write to us about ongoing claims. If you need to report a new claim, you can do this here:",
    "nb-NO":
      "Here you can write to us about ongoing claims. If you need to report a new claim, you can do this here:",
  },

  CategoryNotification_PersonClaims: {
    "en-GB":
      "Here you can write to us about ongoing claims. If you need to report a new claim, you can do this here:",
    "da-DK":
      "Her kan du skrive til os om igangværende eller tidligere skadesager. Skal du anmelde en ny skade, kan du gøre det her:",
    "fi-FI":
      "Tässä voit lähettää viestin keskeneräiseen vahinkoasiaan liittyen. Uudesta vahingosta voit ilmoittaa täällä:",
    "sv-FI":
      "Här kan du skicka meddelande om pågående skada. Du kan anmäla en ny skada här:",
    "sv-SE":
      "Here you can write to us about ongoing claims. If you need to report a new claim, you can do this here:",
    "nb-NO":
      "Here you can write to us about ongoing claims. If you need to report a new claim, you can do this here:",
  },

  CategoryNotification_PropertyClaims: {
    "en-GB":
      "Here you can write to us about ongoing claims. If you need to report a new claim, you can do this here:",
    "da-DK":
      "Her kan du skrive til os om igangværende eller tidligere skadesager. Skal du anmelde en ny skade, kan du gøre det her:",
    "fi-FI":
      "Tässä voit lähettää viestin keskeneräiseen vahinkoasiaan liittyen. Uudesta vahingosta voit ilmoittaa täällä:",
    "sv-FI":
      "Här kan du skicka meddelande om pågående skada. Du kan anmäla en ny skada här:",
    "sv-SE":
      "Here you can write to us about ongoing claims. If you need to report a new claim, you can do this here:",
    "nb-NO":
      "Here you can write to us about ongoing claims. If you need to report a new claim, you can do this here:",
  },

  CategoryNotification_TravelClaims: {
    "en-GB":
      "Here you can write to us about ongoing claims. If you need to report a new claim, you can do this here:",
    "da-DK":
      "Her kan du skrive til os om igangværende eller tidligere skadesager. Skal du anmelde en ny skade, kan du gøre det her:",
    "fi-FI":
      "Tässä voit lähettää viestin keskeneräiseen vahinkoasiaan liittyen. Uudesta vahingosta voit ilmoittaa täällä:",
    "sv-FI":
      "Här kan du skicka meddelande om pågående skada. Du kan anmäla en ny skada här:",
    "sv-SE":
      "Here you can write to us about ongoing claims. If you need to report a new claim, you can do this here:",
    "nb-NO":
      "Here you can write to us about ongoing claims. If you need to report a new claim, you can do this here:",
  },

  CategoryNotificationLinkText_MotorClaims: {
    "en-GB": "Report a claim",
    "da-DK": "Anmeld skade",
    "fi-FI": "Ilmoita vahingosta.",
    "sv-FI": "Anmäl skada.",
    "sv-SE": "Anmäl skada",
    "nb-NO": "Report a claim",
  },

  CategoryNotificationLinkText_PersonClaims: {
    "en-GB": "Report a claim",
    "da-DK": "Anmeld skade",
    "fi-FI": "Ilmoita vahingosta.",
    "sv-FI": "Anmäl skada.",
    "sv-SE": "Anmäl skada",
    "nb-NO": "Report a claim",
  },

  CategoryNotificationLinkText_PropertyClaims: {
    "en-GB": "Report a claim",
    "da-DK": "Anmeld skade",
    "fi-FI": "Ilmoita vahingosta.",
    "sv-FI": "Anmäl skada.",
    "sv-SE": "Anmäl skada",
    "nb-NO": "Report a claim",
  },

  CategoryNotificationLinkText_TravelClaims: {
    "en-GB": "Report a claim",
    "da-DK": "Anmeld skade",
    "fi-FI": "Ilmoita vahingosta.",
    "sv-FI": "Anmäl skada.",
    "sv-SE": "Anmäl skada",
    "nb-NO": "Report a claim",
  },

  MessageCategory_ExistingClaim: {
    "en-GB": "Report or ask about claim",
    "da-DK": "Report or ask about claim",
    "fi-FI": "Ilmoita tai kysy vahingosta.",
    "sv-FI": "Anmäla eller fråga om skada.",
    "sv-SE": "Anmäla eller fråga om skada",
    "nb-NO": "Skadesak",
  },

  MessageCategory_AnimalInsurance: {
    "en-GB": "Ask about pet insurance",
    "da-DK": "Ask about pet insurance",
    "fi-FI": "Kysy eläinvakuutuksesta",
    "sv-FI": "Fråga om djurförsäkring",
    "sv-SE": "Fråga om djurförsäkring",
    "nb-NO": "Ask about pet insurance",
  },

  CategoryNotification_ExistingClaim_Banner: {
    "en-GB":
      "You can report a new claim or send a message about an ongoing claim on the ",
    "da-DK":
      "You can report a new claim or send a message about an ongoing claim on the ",
    "fi-FI":
      "Voit ilmoittaa uudesta vahingosta tai lähettää viestin keskeneräiseen vahinkoasiaan liittyen ",
    "sv-FI":
      "Du kan anmäla en ny skada eller skicka meddelande om en pågående skada på sidan ",
    "sv-SE":
      "Du kan anmäla en ny skada eller skicka meddelande om en pågående skada på sidan ",
    "nb-NO": "",
  },

  CategoryNotification_ExistingClaim_BannerLinkText: {
    "en-GB": "Claim page",
    "da-DK": "Claim page",
    "fi-FI": "Omat vahingot -sivulla",
    "sv-FI": "Mina skador",
    "sv-SE": "Skador",
    "nb-NO": "Meld ny skade",
  },

  CategoryNotificationLinkText_ExistingClaim: {
    "en-GB": "Go to Claims page",
    "da-DK": "Go to Claims page",
    "fi-FI": "Omat vahingot -sivulle",
    "sv-FI": "Till Mina skador",
    "sv-SE": "Gå till Skador",
    "nb-NO": "Send melding om en meldt skade",
  },

  ContactDetailsHeader: {
    "en-GB": "Contact detail",
    "da-DK": "Kontaktoplysninger",
    "fi-FI": "Yhteystiedot",
    "sv-FI": "Kontaktuppgifter",
    "sv-SE": "Kontaktuppgifter",
    "nb-NO": "Contact detail",
  },

  ContactDetailsInformationText: {
    "en-GB":
      "We need your email or phone number before you can send messages to If through My pages.",
    "da-DK":
      "Vi skal bruge din mail eller telefonnummer, før at du kan sende beskeder til If gennem Mine sider.",
    "fi-FI":
      "Tarvitsemme sähköpostiosoitteesi tai puhelinnumerosi ennen kun voit lähettää viestin Omilta sivuilta.",
    "sv-FI":
      "Vi behöver ha din mejladress eller ditt telefonnummer för att skicka ditt meddelande via Mina sidor.",
    "sv-SE":
      "Vi behöver ha din mejladress eller ditt telefonnummer för att skicka ditt meddelande via Mina sidor.",
    "nb-NO":
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam rhoncus nulla a risus bibendum, id elementum orci porta. Aenean ornare est nec nibh sagittis condimentum. Cras eget venenatis ante, a ultrices lectus. Fusce viverra elit non lacus convallis elementum. Donec vel finibus massa. Cras vel tristique dui. Phasellus non tempus purus. Ut vitae ante ipsum.",
  },

  SaveContactDetailsButtonText: {
    "en-GB": "OK",
    "da-DK": "OK",
    "fi-FI": "OK",
    "sv-FI": "OK",
    "sv-SE": "OK",
    "nb-NO": "OK",
  },
};

export const loadEpiTranslationsFromCurrentPage = (): void => {
  const processedTranslations = epiTranslations;

  const translations = document.querySelectorAll(
    '[data-secure-messaging-type="translation"]',
  );

  translations.forEach((translation) => {
    const htmlTranslation = translation as HTMLElement;

    if (htmlTranslation.dataset === undefined) {
      return;
    }

    const category = htmlTranslation.dataset.category;
    const key = htmlTranslation.dataset.key;
    const value = htmlTranslation.dataset.value;

    if (!category || !key || value === undefined) {
      return;
    }

    if (
      !Object.prototype.hasOwnProperty.call(processedTranslations, category)
    ) {
      processedTranslations[category] = {};
    }
    processedTranslations[category][key] = value;
  });

  epiTranslations = processedTranslations;
};

export let epiTranslations: TranslationCatalog = {
  sendReply: {
    successHeaderText: "Missing translation",
    successBodyText: "Missing translation",
    successButtonText: "Missing translation",

    failureHeaderText: "Missing translation",
    failureBodyText: "Missing translation",
    failureButtonText: "Missing translation",

    closeButtonAriaLabel: "Missing translation",
  },
};

export default (
  cultureCode: string | null | undefined,
  term: string,
): string => {
  if (!cultureCode) {
    return "";
  }

  if (
    translations[term] &&
    (translations[term][cultureCode] || translations[term][cultureCode] === "")
  ) {
    return translations[term][cultureCode];
  }

  return term;
};
